import { Injectable } from "@angular/core";
import {
	CanActivate,
	ActivatedRouteSnapshot,
	RouterStateSnapshot,
	Router,
} from "@angular/router";
import { UserService } from "../core/services/user.service";
import { isNativeIos } from "../core/utils/browser-support";
import { EntitlementService } from "../core/services/entitlement.service";

@Injectable({
	providedIn: "root",
})
export class ActiveSubAuthGuardService implements CanActivate {
	constructor(
		private user: UserService,
		private router: Router,
		private entitlementService: EntitlementService
	) { }

	async canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
		this.user.requestedRoute = state.url;

		await this.user.waitForAuthReady();

		const fbUser = await this.user.afAuth.currentUser;
		if (!fbUser) {
			return this.router.createUrlTree(["/login"], {
				queryParams: { returnUrl: state.url },
			});
		}

		const ok = await this.user.ensureLoggedInUserLoaded(fbUser.uid);
		if (!ok) {
			return this.router.createUrlTree(["/login"], {
				queryParams: { returnUrl: state.url },
			});
		}

		const path = next.routeConfig?.path || "";
		const isAllowed = this.entitlementService.canAccessCentralPath(
			this.user.loggedInUser,
			path
		);

		if (isAllowed) {
			this.user.refreshRequestedRoute = state.url;
			return true;
		}

		if (isNativeIos()) {
			return this.router.createUrlTree(["/subscription-access"], {
				queryParams: {
					accessUnavailable: path || "feature",
				},
			});
		}

		return this.router.createUrlTree(["/subscription-access"], {
			queryParams: {
				accessUnavailable: path || "feature",
			},
		});
	}
}
